import React from 'react';
import {
    Typography,
    Grid,
    Paper,
    Divider,
    Box,
    Checkbox,
    FormControlLabel,
    FormHelperText,
    List,
    ListItem,
    ListItemText,
    Chip
} from '@mui/material';
import { User, Briefcase, MapPin } from 'lucide-react';
import { StepProps } from './TypeCadEscriComponents';

const ReviewStep: React.FC<StepProps> = ({ formik, activeStep }) => {
    if (activeStep !== 3) return null;

    const handleAgreeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        formik.setFieldValue('agreeToTerms', event.target.checked);
    };

    return (
        <Box sx={{ mt: 2 }}>
            <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
                Revise suas informações
            </Typography>

            <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                    <Paper elevation={0} sx={{ p: 3, bgcolor: 'background.default', height: '100%' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                            <User size={20} color="#1a237e" />
                            <Typography variant="h6" sx={{ ml: 1, fontSize: '1rem' }}>
                                Dados Pessoais
                            </Typography>
                        </Box>
                        <Divider sx={{ mb: 2 }} />
                        <List dense disablePadding>
                            <ListItem disablePadding sx={{ mb: 1 }}>
                                <ListItemText
                                    primary="Name"
                                    secondary={`${formik.values.proprietario}`}
                                />
                            </ListItem>
                            <ListItem disablePadding sx={{ mb: 1 }}>
                                <ListItemText
                                    primary="Email"
                                    secondary={formik.values.email_escritorio}
                                />
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemText
                                    primary="Phone"
                                    secondary={formik.values.telefone_escritorio}
                                />
                            </ListItem>
                        </List>
                    </Paper>
                </Grid>

                <Grid item xs={12} md={4}>
                    <Paper elevation={0} sx={{ p: 3, bgcolor: 'background.default', height: '100%' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                            <Briefcase size={20} color="#1a237e" />
                            <Typography variant="h6" sx={{ ml: 1, fontSize: '1rem' }}>
                                Dados Profissionais
                            </Typography>
                        </Box>
                        <Divider sx={{ mb: 2 }} />
                        <List dense disablePadding>
                            <ListItem disablePadding sx={{ mb: 1 }}>
                                <ListItemText
                                    primary={formik.values.tipopessoa === 'fisica' ? 'CPF' : 'CNPJ'}
                                    secondary={formik.values.cnpj_escritorio}
                                />
                            </ListItem>
                            <ListItem disablePadding sx={{ mb: 1 }}>
                                <ListItemText
                                    primary="Nome Fantasia Escritorio"
                                    secondary={formik.values.nome_escritorio}
                                />
                            </ListItem>
                        </List>
                    </Paper>
                </Grid>

                <Grid item xs={12} md={4}>
                    <Paper elevation={0} sx={{ p: 3, bgcolor: 'background.default', height: '100%' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                            <MapPin size={20} color="#1a237e" />
                            <Typography variant="h6" sx={{ ml: 1, fontSize: '1rem' }}>
                                Endereço
                            </Typography>
                        </Box>
                        <Divider sx={{ mb: 2 }} />
                        <List dense disablePadding>
                            <ListItem disablePadding sx={{ mb: 1 }}>
                                <ListItemText
                                    primary="Endereço"
                                    secondary={formik.values.endereco_escritorio}
                                />
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemText
                                    primary="Distrito"
                                    secondary={`${formik.values.cidade_escritorio}, ${formik.values.uf_escritorio} ${formik.values.cep_escritorio}`}
                                />
                            </ListItem>
                        </List>
                    </Paper>
                </Grid>

                <Grid item xs={12} sx={{ mt: 2 }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={formik.values.agreeToTerms}
                                onChange={handleAgreeChange}
                                name="agreeToTerms"
                                color="primary"
                            />
                        }
                        label={
                            <Typography variant="body2">
                                Confirmo que todas as informações fornecidas são precisas e concordo com os Termos de Serviço e a Política de Privacidade
                            </Typography>
                        }
                    />
                    {formik.touched.agreeToTerms && formik.errors.agreeToTerms && (
                        <FormHelperText error>{formik.errors.agreeToTerms as string}</FormHelperText>
                    )}
                </Grid>
            </Grid>
        </Box>
    );
};

export default ReviewStep;